import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import {
  CreateCustomerConfigurationResponse,
  Customer,
  UpdateCustomerConfigurationRequest,
} from '../../api/models';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { getAll as getAllCustomersFn } from '../../api/fn/customer-configuration/get-all';
import {
  update_1 as updateCustomer,
  Update_1$Params,
} from '../../api/fn/customer-configuration/update-1';
import { UpdateOrganizationParams } from '../../types/types';
import {
  getByOrganizationId_2 as getCustomerByIdFn,
  GetByOrganizationId_2$Params,
} from '../../api/fn/customer-configuration/get-by-organization-id-2';
import {
  Create_1$Params,
  create_1 as createCustomerFn,
} from '../../api/fn/customer-configuration/create-1';
import {
  DeleteCustomerConfiguration$Params,
  deleteCustomerConfiguration as deleteCustomerCOnfigurationFn,
} from '../../api/fn/customer-configuration/delete-customer-configuration';

@Injectable({ providedIn: 'root' })
export class CustomerService {
  constructor(private apiService: ApiService) {}

  private _customers$!: Observable<Customer[] | undefined>;

  getAllCustomers(): Observable<Customer[] | undefined> {
    if (!this._customers$) {
      this._customers$ = this.apiService.invoke(getAllCustomersFn).pipe(
        map((data) => data.customers),
        shareReplay(1)
      );
    }
    return this._customers$;
  }

  getCustomerById(
    params: GetByOrganizationId_2$Params
  ): Observable<Customer | undefined> {
    return this.apiService
      .invoke(getCustomerByIdFn, params)
      .pipe(map((data) => data.customer));
  }

  createCustomer(
    params: Create_1$Params
  ): Observable<CreateCustomerConfigurationResponse> {
    return this.apiService.invoke(createCustomerFn, params);
  }

  updateCustomer(
    customerParams: UpdateOrganizationParams
  ): Observable<boolean> {
    // Build payload, request parameters for POST request
    const updateBody: UpdateCustomerConfigurationRequest = {
      authenticationType: customerParams.organizationAuthType,
      organizationName: customerParams.organizationName,
      enabled: customerParams.organizationStatus,
      integrationPartnerIds: customerParams.organizationPartnerIds,
    };
    const params: Update_1$Params = {
      organizationId: customerParams.organizationId,
      body: updateBody,
    };

    return this.apiService.invoke(updateCustomer, params).pipe(
      map(() => true),
      catchError((e) => {
        return of(false);
      })
    );
  }

  deleteCustomer(
    params: DeleteCustomerConfiguration$Params
  ): Observable<boolean> {
    return this.apiService.invoke(deleteCustomerCOnfigurationFn, params).pipe(
      map(() => true),
      catchError(() => {
        return of(false);
      })
    );
  }
}
